
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrderTiss, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class OrderTissEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    orderTiss: OrderTiss;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getOrderTiss()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getOrderTiss(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.orderTiss = data;
                this.onDataChanged.next(this.orderTiss);
                resolve(this.orderTiss);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('order/tiss/' + this.routeParams.id).subscribe((res: OrderTiss ) => {
                    this.orderTiss = res;
                    this.onDataChanged.next(this.orderTiss);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(orderTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('order/tiss/', orderTiss).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(orderTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('order/tiss/', orderTiss).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(orderTiss): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('order/tiss/' + orderTiss.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): OrderTiss {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
